import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/material";
import { SelectField } from "../../../Form/Form";
import { EditorControlled } from "../../../Form/FormComponents";
import { FinalStepDealProps, LandlordWorksSchema } from "../../DealConfig";

export const NO_OPTION_USE = { label: "Other", value: -1 };

export const LandlordWorks = (props: FinalStepDealProps) => {
  const form = useForm({
    resolver: yupResolver(LandlordWorksSchema),
    defaultValues: props.state,
    mode: "onChange",
  });

  const landlordWorksOptions = [
    {
      value: "asPerFitoutGuide",
      label: "As per fitout guide",
    },
    {
      value: "asIsWhereIs",
      label: '"As is where is" condition',
    },
    {
      value: "other",
      label: "Other",
    },
  ];

  return (
    <Box width="100%">
      <SelectField
        form={form}
        formField={{
          type: "select",
          fieldName: "landlordWorks",
          helperText: "",
          choices: landlordWorksOptions,
          label: "Landlord works:",
          onChange: (_, choice) => {
            let preview = "";

            if (choice.value === "asPerFitoutGuide") {
              preview =
                "Refer to the Charter Hall Retail Fitout Guide for details of the 'bare shell' that will be provided by the Landlord.";
            } else if (choice.value === "asIsWhereIs") {
              preview =
                "Nil works by Landlord. The Landlord Works referred to in the Charter Hall Retail Fitout Guide do not apply, with the Premises to be provided by the Landlord in an ‘as is, where is’ condition.";
            }
            form.setValue("landlordWorksPreview", preview);

            props.setState((prev) => ({
              ...prev,
              landlordWorks: choice,
              landlordWorksPreview: choice.value === "other" ? "" : preview,
            }));
          },
        }}
      />

      <Box p={1} width="100%" />

      <EditorControlled
        label="Preview"
        name="landlordWorksPreview"
        control={form.control}
        onChange={(data) => {
          props.setState((prev) => ({
            ...prev,
            landlordWorksPreview: data ?? "",
          }));
        }}
      />
    </Box>
  );
};
